import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class UtilsService {
  handleFileInput(
    files: FileList,
    maxFileSize_kBytes: number,
    allowedFileTypesToUpload: string,
    fileSizeError: string,
    fileTypeError: string
  ) {
    const serviceResult = {
      result: false,
      file: null,
      error: '',
    };

    if (files.length === 0) {
      serviceResult.error = 'File not found!';
      return serviceResult;
    }

    const file: File = files[0];
    const fileExtension = file.name?.split('.')?.splice(-1)[0];

    if (
      fileExtension
      && allowedFileTypesToUpload.split(',').indexOf('.' + fileExtension) === -1
    ) {
      serviceResult.error = fileTypeError + allowedFileTypesToUpload;
      return serviceResult;
    }

    if (file.size > maxFileSize_kBytes * 1024) {
      serviceResult.error = fileSizeError + maxFileSize_kBytes + 'Kb';
      return serviceResult;
    }

    serviceResult.result = true;
    serviceResult.file = files[0];
    return serviceResult;
  }

  scrollToTop() {
    window.scrollTo(0, 0);
  }

  b64toBlob(b64Data, contentType, sliceSize) {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);

      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  /**
   * Удаляем значение чтобы можно было загрузить один файл дважды (!)подряд(!)
   */
  cleanFileInput(target: HTMLInputElement) {
    target.value = '';
  }
}
